// extracted by mini-css-extract-plugin
export default {"overlay":"PageSnow_overlay__Ewkmp"};